import { BULK_UPLOAD_PRODUCT, CREATE_PRODUCT, DELETE_PRODUCT, EDIT_PRODUCT, LIST_PRODUCT, VIEW_PRODUCT } from "./types";


export const createProductAction = (data, onSuccess, onError) => {
    return {
        type: CREATE_PRODUCT,
        data,
        onSuccess,
        onError,
    };
};

export const editProductAction = (data, onSuccess, onError) => {
    return {
        type: EDIT_PRODUCT,
        data,
        onSuccess,
        onError,
    };
};

export const listProductAction = (data, onSuccess, onError) => {
    return {
        type: LIST_PRODUCT,
        data,
        onSuccess,
        onError,
    };
};

export const viewProductAction = (data, onSuccess, onError) => {
    return {
        type: VIEW_PRODUCT,
        data,
        onSuccess,
        onError,
    };
};

export const deleteProductAction = (data, onSuccess, onError) => {
    return {
        type: DELETE_PRODUCT,
        data,
        onSuccess,
        onError,
    };
};

export const bulkUploadProductAction = (file, onSuccess, onError) => {
    return {
        type: BULK_UPLOAD_PRODUCT,
        file,
        onSuccess,
        onError,
    };
};